import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import Modal from '../shared/Modal';
import PropTypes from 'prop-types';
import { mapContextToProps } from '../OlsShopContext';

const styles = {
  copyBox: {
    textAlign: 'center',
    paddingBottom: 'medium'
  },
  header: {
    textAlign: 'center',
    paddingBottom: 'medium'
  },
  submitButton: {
    marginBottom: 'medium'
  }
};

export class SuccessModal extends React.Component {
  get content() {
    const { Text, Block, Button, DisplayHeading } = UX2.Element;
    const { Form } = UX2.Group;
    const translate = this.props.translate || (() => {});
    const successMessage = translate('coming_soon_modal.success');
    const ok = translate('coming_soon_modal.ok');
    const title = translate('coming_soon_modal.title');

    return (
      <React.Fragment>
        <DisplayHeading style={ styles.header } children={ title } />
        <Block style={ styles.copyBox }>
          <Text children={ successMessage } />
        </Block>

        <Form action='#' onSubmit={ this.props.closeModal }>
          <Button.Primary size='small' style={ styles.submitButton } type='submit' children={ ok } />
        </Form>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal
        renderMode={ this.props.renderMode }
        closeModal={ this.props.closeModal }
        closeOnClickOutside={ true }
      >
        { this.content }
      </Modal>
    );
  }
}

SuccessModal.propTypes = {
  renderMode: PropTypes.string,
  closeModal: PropTypes.func,
  translate: PropTypes.func
};

export default mapContextToProps(SuccessModal, context => ({
  translate: context.translate
}));
